/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the pick truly random?`)
};

const es_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es realmente aleatoria la elección?`)
};

const de_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist die Auswahl wirklich zufällig?`)
};

const nl_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is de keuze echt willekeurig?`)
};

const fr_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tirage est-il vraiment aléatoire ?`)
};

const it_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scelta è davvero casuale?`)
};

const pt_br2_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O sorteio é realmente aleatório?`)
};

const pt_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A escolha é verdadeiramente aleatória?`)
};

const ja_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択は本当にランダムですか?`)
};

const zh_dw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抽取结果真的是随机的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_q1", locale)
	if (locale === "en") return en_dw_faq_q1(inputs)
	if (locale === "es") return es_dw_faq_q1(inputs)
	if (locale === "de") return de_dw_faq_q1(inputs)
	if (locale === "nl") return nl_dw_faq_q1(inputs)
	if (locale === "fr") return fr_dw_faq_q1(inputs)
	if (locale === "it") return it_dw_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_q1(inputs)
	if (locale === "pt") return pt_dw_faq_q1(inputs)
	if (locale === "ja") return ja_dw_faq_q1(inputs)
	return zh_dw_faq_q1(inputs)
};